import React, { FC } from 'react';
import Link from 'next/link';
import IcomoonIcon from '../../atoms/icomoon-icon/icomoon-icon';
import { USPItemType } from '../../../models/product-card-labels-type';

interface Props {
  items: USPItemType[];
}

const UspList: FC<Props> = ({ items }) => {
  return (
    <ul className="py-4">
      {items.map((item) => (
        <li
          key={item.title}
          className="flex pb-2 items-center hover: cursor-pointer"
        >
          <IcomoonIcon
            name="check-circle"
            color="turquoise"
            size="s"
            className="pr-2"
          />
          <Link href={item.link.url}>
            <span className="text-sm">{item.title}</span>
          </Link>
        </li>
      ))}
    </ul>
  );
};

export default UspList;
